/**
 * Created by Karol Kluska on 14.12.17.
 */
/**
 * Created by Karol Kluska on 27.06.17.
 */

angular
  .module('app')
  .factory('ConfigBookingEngine', ConfigBookingEngine);

function ConfigBookingEngine() {
  var config = {};

  function setConfig(bookingEngineConfig) {
    config = bookingEngineConfig;
  }

  function getAvailableLanguages() {
    return config.available_languages || ['EN'];
  }

  function getAgeCategories() {
    return config.age_categories || [];
  }

  function isBookingEngineEnabled() {
    if (angular.isDefined(config.enabled)) {
      return config.enabled;
    }
    return false;
  }

  function isHostelViewEnabled() {
    if (angular.isDefined(config.show_hostel_view)) {
      return config.show_hostel_view;
    }
    return false;
  }

  function getHotel() {
    return config.hotel || {};
  }

  function getRegulations() {
    return config.regulations || '';
  }

  function getRegulationsRodo() {
    return config.regulations_rodo || null;
  }

  function isDiscountCodesEnabled() {
    return config.discount_codes_enabled;
  }

  function getMaxAvailableRooms() {
    return config.max_selected_rooms;
  }

  function getSortOffersMethod() {
    return config.sort_offers_method || '';
  }

  function showUnavailableOffers() {
    if (angular.isDefined(config.show_unavailable_offers)) {
      return config.show_unavailable_offers;
    }
    return true;
  }

  function showUnavailableRateplans() {
    if (angular.isDefined(config.show_unavailable_rateplans)) {
      return config.show_unavailable_rateplans;
    }
    return true;
  }

  function showCategoriesFilter() {
    if (angular.isDefined(config.show_categories_filter)) {
      return config.show_categories_filter;
    }
    return false;
  }

  function showRateplanAvailability() {
    if (angular.isDefined(config.show_rateplan_availability)) {
      return config.show_rateplan_availability;
    }
    return false;
  }

  function showEquipment() {
    if (angular.isDefined(config.show_equipment)) {
      return config.show_equipment;
    }
    return false;
  }

  return {
    setConfig: setConfig,
    getAvailableLanguages: getAvailableLanguages,
    getAgeCategories: getAgeCategories,
    isBookingEngineEnabled: isBookingEngineEnabled,
    isHostelViewEnabled: isHostelViewEnabled,
    getHotel: getHotel,
    getRegulations: getRegulations,
    getRegulationsRodo: getRegulationsRodo,
    isDiscountCodesEnabled: isDiscountCodesEnabled,
    getMaxAvailableRooms: getMaxAvailableRooms,
    getSortOffersMethod: getSortOffersMethod,
    showUnavailableOffers: showUnavailableOffers,
    showUnavailableRateplans: showUnavailableRateplans,
    showCategoriesFilter: showCategoriesFilter,
    showRateplanAvailability: showRateplanAvailability,
    showEquipment: showEquipment
  };
}
